import { render, staticRenderFns } from "./AjusteContaForm.vue?vue&type=template&id=2aa0558a&scoped=true"
import script from "./AjusteContaForm.vue?vue&type=script&lang=js"
export * from "./AjusteContaForm.vue?vue&type=script&lang=js"
import style0 from "./AjusteContaForm.vue?vue&type=style&index=0&id=2aa0558a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa0558a",
  null
  
)

export default component.exports